import React from 'react';
import IconSearch from "@assets/tsx/icon/search";
export function SearchControl({ placeholder, onChange, value, autofocus }) {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "ltg-search-control-wrap" },
            React.createElement("input", { type: "text", className: "ltg-search-control", value: value || '', placeholder: placeholder, onChange: ({ target }) => {
                    onChange && onChange(target.value);
                }, autoFocus: autofocus }),
            React.createElement("span", { className: "ltg-search" },
                React.createElement(IconSearch, null)))));
}
